import { useNavigation } from '@react-navigation/native'
import { externalLinks, links } from 'constants'
import React from 'react'

import { EmptyState } from 'partials/EmptyState'

import { Box } from 'widgets/Box'

import { useCurrentUser } from 'hooks/useCurrentUser'

import { handleShareAction } from 'utils/sharing'

export const FeedEmptyState = () => {
  const navigation = useNavigation()
  const { data: currentUser } = useCurrentUser()

  const navigateToUpspacesPage = () => {
    navigation.navigate(links.TRAINERS_PAGE)
  }

  const navigateToWorkoutsPage = () => {
    navigation.navigate(links.WORKOUTS_PAGE)
  }

  const handleInviteFriend = async () => {
    const url =
      `${externalLinks.UPSPACE_FULL_PATH}/feed/profile/${currentUser?.username}`.toLocaleLowerCase()

    const message = `Join me on Upspace!`
    handleShareAction(url, message, navigation, links.SHARE_PROFILE_PAGE)
  }

  return (
    <Box flex={1}>
      <EmptyState
        title='Feed'
        subtitle='Your feed will populate with content from friends, those you follow, and Groups that you’ve joined'
        actionButtons={[
          {
            title: 'Discover Groups',
            type: 'primary',
            onPress: navigateToUpspacesPage,
          },
          {
            title: 'Find Workouts',
            type: 'secondary',
            onPress: navigateToWorkoutsPage,
          },
          {
            title: 'Invite a Friend',
            type: 'secondary',
            onPress: handleInviteFriend,
          },
        ]}
      />
    </Box>
  )
}
